// extracted by mini-css-extract-plugin
module.exports = {"excarousel-dots":"ExCarouselDots_excarousel-dots__L3lT5","dot":"ExCarouselDots_dot__Tzy0x","active":"ExCarouselDots_active__i4y1l"};